import React from 'react';
import Lottie from 'lottie-react';
import PropTypes from 'prop-types';
import { AnimationWrapper } from './LottieAnimation.styles';

const LottieAnimation = ({
  animationData,
  width = '400px',
  height = '400px',
  loop = true,
  autoplay = true,
  ...props
}) => {
  return (
    <AnimationWrapper width={width} height={height}>
      <Lottie
        animationData={animationData}
        loop={loop}
        autoplay={autoplay}
        {...props}
      />
    </AnimationWrapper>
  );
};

LottieAnimation.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  animationData: PropTypes.object.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  loop: PropTypes.bool,
  autoplay: PropTypes.bool,
};

export default LottieAnimation;
